// Right-click context menu helpers. The menu element lives in
// CanvasOverlayV2 (`CvContextMenu`) and is repositioned imperatively.

export function showContextMenu(ev, key) {
  const menu = this.getRoot?.()?.lookdown?.('CvContextMenu')
  if (!menu?.update) return
  ev.preventDefault?.(); ev.stopPropagation?.()
  // If clicked on an item, ensure that item is selected (single-select
  // unless it's already part of multi-select).
  if (key) {
    const v2 = this.call('getCanvasV2')
    if (v2 && !v2.selection.ids.includes(key)) this.call('selectOne', key)
  }
  menu.update({ style: { display: 'block', left: ev.clientX + 'px', top: ev.clientY + 'px' } })
  // Auto-hide on next outside click.
  if (!menu.__cmDocListener) {
    menu.__cmDocListener = true
    const close = (e) => {
      if (menu.node?.contains?.(e.target)) return
      this.call('hideContextMenu')
    }
    document.addEventListener('mousedown', close, { capture: true, once: true })
  }
}

export function hideContextMenu() {
  const menu = this.getRoot?.()?.lookdown?.('CvContextMenu')
  if (!menu?.update) return
  menu.__cmDocListener = false
  menu.update({ style: { display: 'none' } })
}
